import React from "react";
import Loader from "./Loader";
import NmsDurationMenu from "./NmsDurationMenu";

const NmsChartCard = ({
  title,
  onExpand,
  duration,
  onDurationChange,
  localizationStrings,
  loading,
  hasData,
  extra,
  children,
}) => (
  <div className="inc-card nms-chart-card">
    <div className="inc-card-title">
      <h3>
        {title}
        {onExpand ? (
          <span onClick={onExpand}>
            <i className="fa fa-arrows-alt" aria-hidden="true"></i>
          </span>
        ) : null}
      </h3>
      {(extra || (duration != null && onDurationChange)) && (
        <div className="inc-card-button">
          {extra}
          {duration != null && onDurationChange ? (
            <NmsDurationMenu
              value={duration}
              onChange={onDurationChange}
              localizationStrings={localizationStrings}
            />
          ) : null}
        </div>
      )}
    </div>
    <div className="inc-card-body">
      {loading ? (
        <Loader />
      ) : hasData ? (
        children
      ) : (
        <div className="nms-empty">
          {localizationStrings?.noData || "No data"}
        </div>
      )}
    </div>
  </div>
);

NmsChartCard.displayName = "NmsChartCard";

export default NmsChartCard;
